<template>
    <el-dialog
        :visible.sync="dialogVisible"
        custom-class="angle-guide-dialog-shell"
        width="760px"
        top="5vh"
        append-to-body
        :close-on-click-modal="false"
    >
        <div slot="title" class="angle-guide-header">
            <div>
                <div class="angle-guide-title">角度设置操作指引</div>
                <div class="angle-guide-subtitle">先确认机械臂能否转到目标开关</div>
            </div>
        </div>

        <div class="angle-guide-content">
            <div class="angle-guide-summary">
                <div class="summary-icon">
                    <i class="el-icon-refresh-right"></i>
                </div>
                <div class="summary-content">
                    <div class="summary-title">默认活动范围：右侧 0-180°</div>
                    <div class="summary-text">机械臂只能在机身右侧上下转动，最大旋转范围0-180°</div>
                </div>
            </div>

            <div class="angle-diagram-viewport">
                <div class="angle-diagram">
                    <div class="reachable-zone"></div>
                    <div class="blind-zone-arc"></div>

                    <div class="angle-ray angle-ray-180"></div>
                    <div class="angle-ray angle-ray-135"></div>
                    <div class="angle-ray angle-ray-90"></div>
                    <div class="angle-ray angle-ray-45"></div>
                    <div class="angle-ray angle-ray-0"></div>

                    <div class="robot-body-shape">
                        <div class="robot-body-highlight"></div>
                        <div class="robot-body-label">机器人机身</div>
                    </div>

                    <div class="robot-arm">
                        <div class="robot-arm-slot"></div>
                    </div>
                    <div class="robot-arm-pivot"></div>

                    <span class="diagram-label label-180">180°</span>
                    <span class="diagram-label label-90">90°</span>
                    <span class="diagram-label label-0">0°</span>
                    <span class="sector-label sector-upper">90-180°</span>
                    <span class="sector-label sector-lower">0-90°</span>

                    <div class="blind-zone-label">
                        <div class="blind-zone-title">不可达区域</div>
                        <div class="blind-zone-text">机械臂无法转到左侧</div>
                    </div>

                    <div class="current-arm-label">默认指向右侧</div>
                </div>
            </div>

            <div class="angle-guide-points">
                <div class="angle-guide-point">
                    <div class="point-marker point-marker-blue">1</div>
                    <div class="point-content">
                        <div class="point-title">认识角度方向</div>
                        <div class="point-text">0° 向下、90° 向右、180° 向上，蓝色区域内都可以设置。</div>
                    </div>
                </div>
                <div class="angle-guide-point">
                    <div class="point-marker point-marker-red">2</div>
                    <div class="point-content">
                        <div class="point-title">确认目标是否在盲区</div>
                        <div class="point-text">左侧红色弧线是机械结构无法到达的区域，角度设置不能突破此限制。</div>
                    </div>
                </div>
            </div>

            <div class="direction-tip">
                <div class="direction-tip-header">
                    <div class="direction-tip-icon">
                        <i class="el-icon-refresh"></i>
                    </div>
                    <div class="direction-tip-title">如何实现手臂反转？</div>
                </div>
                <div class="direction-tip-text">默认角度比按压角度小，即可让机械臂反向转动。</div>
                <div class="direction-rules">
                    <div class="direction-rule">
                        <span class="direction-rule-formula">默认角度 &gt; 按压角度</span>
                        <span class="direction-rule-result">顺时针转动</span>
                    </div>
                    <div class="direction-rule">
                        <span class="direction-rule-formula">默认角度 &lt; 按压角度</span>
                        <span class="direction-rule-result">逆时针转动</span>
                    </div>
                </div>
            </div>

            <div class="installation-tip">
                <div class="installation-tip-header">
                    <div class="installation-tip-icon">!</div>
                    <div class="installation-tip-title">开关在左侧，机械臂够不到怎么办？</div>
                </div>
                <div class="installation-tip-text">
                    请先断开机器人电源，再用螺丝刀卸下固定机械臂的螺丝，将机械臂拔出并换一个方向重新安装，最后拧紧螺丝。可达区域会随安装方向改变，原来够不到的左侧就能按到。
                </div>
                <div class="installation-steps">
                    <div class="installation-step">
                        <div class="step-number">1</div>
                        <span>断开电源</span>
                    </div>
                    <i class="step-arrow el-icon-arrow-right"></i>
                    <div class="installation-step">
                        <div class="step-number">2</div>
                        <span>拆下机械臂</span>
                    </div>
                    <i class="step-arrow el-icon-arrow-right"></i>
                    <div class="installation-step">
                        <div class="step-number">3</div>
                        <span>换方向装回</span>
                    </div>
                </div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'AngleGuideDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        dialogVisible: {
            get() {
                return this.visible
            },
            set(value) {
                this.$emit('update:visible', value)
            }
        }
    }
}
</script>

<style scoped>
::v-deep .angle-guide-dialog-shell {
    width: min(760px, 94vw) !important;
    overflow: hidden;
    border-radius: 10px;
}

::v-deep .angle-guide-dialog-shell .el-dialog__header {
    padding: 18px 24px;
    background-color: #f0f9ff;
    border-bottom: 1px solid #d9ecff;
}

::v-deep .angle-guide-dialog-shell .el-dialog__headerbtn {
    top: 24px;
    right: 24px;
}

::v-deep .angle-guide-dialog-shell .el-dialog__body {
    max-height: calc(90vh - 92px);
    padding: 22px 24px 28px;
    overflow-y: auto;
}

.angle-guide-title {
    color: #303133;
    font-size: 18px;
    line-height: 24px;
    font-weight: 600;
}

.angle-guide-subtitle {
    margin-top: 3px;
    color: #7a8a9a;
    font-size: 12px;
    line-height: 18px;
}

.angle-guide-summary {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 14px;
    margin-bottom: 16px;
    background-color: #f7fbff;
    border: 1px solid #d9ecff;
    border-radius: 8px;
}

.summary-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    color: #ffffff;
    background-color: #409eff;
    border-radius: 50%;
    font-size: 22px;
}

.summary-content {
    flex: 1;
    min-width: 0;
}

.summary-title {
    color: #303133;
    font-size: 15px;
    line-height: 22px;
    font-weight: 600;
}

.summary-text {
    margin-top: 2px;
    color: #606266;
    font-size: 13px;
    line-height: 20px;
}

.angle-diagram-viewport {
    position: relative;
    width: 100%;
    height: 470px;
    overflow: hidden;
}

.angle-diagram {
    position: absolute;
    top: 0;
    left: 50%;
    width: 650px;
    height: 470px;
    overflow: hidden;
    background-color: #fafcff;
    border: 1px solid #e4eaf1;
    border-radius: 8px;
    box-sizing: border-box;
    transform: translateX(-50%);
    transform-origin: top center;
}

.reachable-zone {
    position: absolute;
    z-index: 1;
    left: 325px;
    top: 55px;
    width: 180px;
    height: 360px;
    background-color: rgba(64, 158, 255, 0.1);
    border: 4px solid #409eff;
    border-left: 0;
    border-radius: 0 360px 360px 0;
    box-sizing: border-box;
}

.blind-zone-arc {
    position: absolute;
    z-index: 1;
    left: 143px;
    top: 55px;
    width: 182px;
    height: 360px;
    border: 5px solid #f56c6c;
    border-right: 0;
    border-radius: 360px 0 0 360px;
    box-sizing: border-box;
}

.angle-ray {
    position: absolute;
    z-index: 2;
    left: 325px;
    top: 233px;
    width: 178px;
    height: 2px;
    background-color: rgba(64, 158, 255, 0.5);
    transform-origin: left center;
}

.angle-ray-180 {
    transform: rotate(-90deg);
}

.angle-ray-135 {
    transform: rotate(-45deg);
}

.angle-ray-90 {
    height: 3px;
    background-color: #409eff;
}

.angle-ray-45 {
    transform: rotate(45deg);
}

.angle-ray-0 {
    transform: rotate(90deg);
}

.robot-body-shape {
    position: absolute;
    z-index: 3;
    left: 215px;
    top: 125px;
    width: 220px;
    height: 220px;
    overflow: hidden;
    background: linear-gradient(145deg, #eaf4ff 0%, #ffffff 58%, #d8eaff 100%);
    border: 5px solid #6d91b8;
    border-radius: 38px;
    box-shadow: 0 10px 24px rgba(70, 110, 150, 0.18);
    box-sizing: border-box;
}

.robot-body-highlight {
    position: absolute;
    top: 18px;
    left: 24px;
    width: 120px;
    height: 18px;
    background-color: rgba(255, 255, 255, 0.85);
    border-radius: 20px;
}

.robot-body-label {
    position: absolute;
    top: 58px;
    right: 0;
    left: 0;
    color: #5d7390;
    font-size: 22px;
    text-align: center;
    font-weight: 600;
}

.robot-arm {
    position: absolute;
    z-index: 5;
    left: 263px;
    top: 265px;
    width: 145px;
    height: 40px;
    background-color: #ffffff;
    border: 5px solid #4c6f91;
    border-radius: 24px;
    box-shadow: 0 5px 10px rgba(55, 88, 120, 0.2);
    box-sizing: border-box;
}

.robot-arm-slot {
    position: absolute;
    top: 50%;
    left: 24px;
    width: 82px;
    height: 8px;
    background-color: #d7e4f0;
    border-radius: 8px;
    transform: translateY(-50%);
}

.robot-arm-pivot {
    position: absolute;
    z-index: 6;
    left: 249px;
    top: 265px;
    width: 40px;
    height: 40px;
    background-color: #409eff;
    border: 5px solid #ffffff;
    border-radius: 50%;
    box-shadow: 0 0 0 3px #4c6f91;
    box-sizing: border-box;
}

.diagram-label,
.sector-label {
    position: absolute;
    z-index: 7;
    color: #1677d2;
    font-size: 24px;
    line-height: 32px;
    font-weight: 700;
    white-space: nowrap;
}

.label-180 {
    left: 301px;
    top: 14px;
}

.label-90 {
    left: 522px;
    top: 217px;
}

.label-0 {
    left: 313px;
    top: 425px;
}

.sector-upper {
    left: 438px;
    top: 51px;
}

.sector-lower {
    left: 448px;
    top: 385px;
}

.blind-zone-label {
    position: absolute;
    z-index: 4;
    left: 52px;
    top: 50%;
    width: 142px;
    padding: 10px 12px;
    background-color: rgba(255, 245, 245, 0.94);
    border: 2px solid #fbc4c4;
    border-radius: 10px;
    box-sizing: border-box;
    transform: translateY(-50%);
}

.blind-zone-title,
.blind-zone-text {
    text-align: center;
}

.blind-zone-title {
    color: #e64b4b;
    font-size: 22px;
    line-height: 32px;
    font-weight: 700;
}

.blind-zone-text {
    margin-top: 2px;
    color: #b35c5c;
    font-size: 17px;
    line-height: 25px;
}

.current-arm-label {
    position: absolute;
    z-index: 7;
    left: 302px;
    top: 313px;
    padding: 3px 10px;
    color: #4c6f91;
    background-color: rgba(255, 255, 255, 0.94);
    border: 2px solid #c9d8e6;
    border-radius: 8px;
    font-size: 19px;
    line-height: 28px;
    white-space: nowrap;
}

.angle-guide-points {
    margin-top: 16px;
    overflow: hidden;
    background-color: #ffffff;
    border: 1px solid #ebeef5;
    border-radius: 8px;
}

.angle-guide-point {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 14px;
}

.angle-guide-point + .angle-guide-point {
    border-top: 1px solid #ebeef5;
}

.point-marker {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    color: #ffffff;
    border-radius: 50%;
    font-size: 13px;
    line-height: 1;
    font-weight: 700;
}

.point-marker-blue {
    background-color: #409eff;
}

.point-marker-red {
    background-color: #f56c6c;
}

.point-content {
    flex: 1;
    min-width: 0;
}

.point-title {
    color: #303133;
    font-size: 15px;
    line-height: 22px;
    font-weight: 600;
}

.point-text {
    margin-top: 2px;
    color: #606266;
    font-size: 13px;
    line-height: 21px;
}

.direction-tip {
    padding: 16px;
    margin-top: 16px;
    background-color: #f0f9ff;
    border: 1px solid #b3d8ff;
    border-radius: 8px;
}

.direction-tip-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.direction-tip-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: #ffffff;
    background-color: #409eff;
    border-radius: 50%;
    font-size: 15px;
    line-height: 1;
    font-weight: 700;
}

.direction-tip-title {
    color: #1677d2;
    font-size: 15px;
    line-height: 22px;
    font-weight: 700;
}

.direction-tip-text {
    margin-top: 9px;
    color: #4c6f91;
    font-size: 13px;
    line-height: 22px;
}

.direction-rules {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    margin-top: 12px;
}

.direction-rule {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 10px 12px;
    background-color: #ffffff;
    border: 1px solid #d9ecff;
    border-radius: 6px;
}

.direction-rule-formula {
    color: #303133;
    font-size: 13px;
    line-height: 20px;
    font-weight: 600;
}

.direction-rule-result {
    color: #409eff;
    font-size: 13px;
    line-height: 20px;
}

.installation-tip {
    padding: 16px;
    margin-top: 16px;
    background-color: #fff6f6;
    border: 1px solid #fbc4c4;
    border-radius: 8px;
}

.installation-tip-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

.installation-tip-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 24px;
    height: 24px;
    color: #ffffff;
    background-color: #f56c6c;
    border-radius: 50%;
    font-size: 15px;
    line-height: 1;
    font-weight: 700;
}

.installation-tip-title {
    color: #d94343;
    font-size: 15px;
    line-height: 22px;
    font-weight: 700;
}

.installation-tip-text {
    margin-top: 9px;
    color: #8f4b4b;
    font-size: 13px;
    line-height: 22px;
}

.installation-steps {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    margin-top: 14px;
}

.installation-step {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    gap: 5px;
    color: #8f4b4b;
    font-size: 12px;
    line-height: 18px;
    text-align: center;
}

.step-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 25px;
    height: 25px;
    color: #f56c6c;
    background-color: #ffffff;
    border: 1px solid #f56c6c;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 700;
}

.step-arrow {
    flex-shrink: 0;
    color: #e58c8c;
    font-size: 20px;
}

@media (max-width: 760px) {
    .angle-diagram-viewport {
        height: 385px;
    }

    .angle-diagram {
        transform: translateX(-50%) scale(0.82);
    }
}

@media (max-width: 560px) {
    ::v-deep .angle-guide-dialog-shell .el-dialog__header {
        padding: 16px 18px;
    }

    ::v-deep .angle-guide-dialog-shell .el-dialog__headerbtn {
        top: 22px;
        right: 18px;
    }

    ::v-deep .angle-guide-dialog-shell .el-dialog__body {
        padding: 16px 14px 20px;
    }

    .angle-guide-subtitle {
        padding-right: 26px;
    }

    .angle-diagram-viewport {
        height: 320px;
    }

    .angle-diagram {
        transform: translateX(-50%) scale(0.68);
    }
}

@media (max-width: 420px) {
    .angle-guide-title {
        font-size: 16px;
    }

    .angle-guide-summary {
        align-items: flex-start;
    }

    .angle-diagram-viewport {
        height: 235px;
    }

    .angle-diagram {
        transform: translateX(-50%) scale(0.5);
    }

    .direction-rules {
        grid-template-columns: 1fr;
    }

    .installation-tip-header {
        align-items: flex-start;
    }
}
</style>
